import gql from "graphql-tag";

export const SEARCH_PRODUCT = gql`
query search_product($search: String){
  products: search_product(args: {search: $search}) {
    id
    name
    Attachments(where: {type: {_eq:"IMAGE"}, isDefault: {_eq:true}}) {id path}
  }
}`

export const SEARCH_PRODUCT_WITH_DETAILS = gql`
query search_product($search: String){
  products: search_product(args: {search: $search}) {
    id
    name
    cartonQty
    purchasePrice
    Attachments(where: {type: {_eq:"IMAGE"}, isDefault: {_eq:true}}) {id path}
  }
}`